export enum EAppHelpNames {
  NOITADA_APP = 'NOITADA_APP',
  NOITADA_ORGANIZER = 'NOITADA_ORGANIZER',
  NOITADA_BACKSTAGE = 'NOITADA_BACKSTAGE',
}


export default EAppHelpNames;
